import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const CanvasCoreRoutes: RouteBundle = {
  domain: 'canvas-core',
  routes: [
    {
      urlPattern: 'canvases/:canvasDefinitionId',
      handler: EditorRoutes.canvasEditor.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: 'canvases/:canvasDefinitionId/v/:canvasVersionId',
      handler: EditorRoutes.canvasVersionEditor.bind(EditorRoutes),
      legacy: false,
    },
  ],
};
